import { render, staticRenderFns } from "./losenge-date-display.vue?vue&type=template&id=080df2c0&scoped=true"
import script from "./losenge-date-display.vue?vue&type=script&lang=js"
export * from "./losenge-date-display.vue?vue&type=script&lang=js"
import style0 from "./losenge-date-display.vue?vue&type=style&index=0&id=080df2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080df2c0",
  null
  
)

export default component.exports